module.exports = __webpack_public_path__ + "img/macot-new.194cd2eb.svg";